import { Heading, ListItem } from '@athena/forge';
import ProxyButton from '../../common/ProxyButton';
import { I18N_MAPPING } from '../../../constants';
import { getLocalizedString } from '../../../utils/i18n-utils';

export interface ChallengeItemPropTypes {
  readonly oktaFactorItem: JQuery;
}

export default function ChallengeItem({ oktaFactorItem }: ChallengeItemPropTypes) {
  let label = oktaFactorItem.find('h3').text();
  let description = oktaFactorItem.find('p').eq(0)
    .text();
  const oktaButton = oktaFactorItem.find('.authenticator-button');

  // Update description programmatically as per requirement as i18n key has been updated as Okta verify
  // and the key is same for description, and other Okta verify screens
  const dataSe = oktaButton.data('se');

  switch (dataSe) {
    case 'okta_verify-totp':
      description = getLocalizedString('challenge.okta.verify.totp.factor.description');
      break;
    case 'okta_verify-push':
      description = getLocalizedString('challenge.okta.verify.push.factor.description');
      break;
    case 'google_otp':
      label = I18N_MAPPING.en['oie.verify.google_authenticator.otp.title'];
      break;
  }


  return (
    <ListItem className="fe_u_flex-container fe_u_margin--bottom-small">
      <div className={oktaFactorItem.attr('class')}>
        <div className={`${oktaFactorItem.children().attr('class')} fe_u_margin--right-medium`}>
          <div className={oktaFactorItem.find('.factor-icon').attr('class')}></div>
        </div>
      </div>
      <div className="factor-challenge-description">
        <Heading
          className="fe_u_font-size--default"
          text={label}
          variant="subsection"
          headingDescription={description}
        ></Heading>
      </div>
      <div>
        <ProxyButton
          oktaButton={oktaButton.find('a')}
          fullWidth={false}
          size="small"
          variant="secondary"
          className={'fe_u_margin--left-medium'}
        />
      </div>
    </ListItem>
  );
}
